export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref12935.d91328cf.jpg";